import { render, staticRenderFns } from "./primary-breadcrumb.vue?vue&type=template&id=ec63980e"
import script from "./primary-breadcrumb.vue?vue&type=script&lang=js"
export * from "./primary-breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports